/*! gtm-controller.js */

import Utils from "app/utils/utils";
import Log from "app/utils/log";
import { version } from "build/shims";
const log = new Log("GoogleTagManager");

const EVENT_CATEGORY = "video";
const EVENT_CATEGORY_DEV = "video-eng";
const EVENT_TRACKING_NAME = "bvpTrackVideo";
const PLAYER_NAME = "bplayer";
const DEFAULT_DATA_LAYER_ID = "dataLayer";
const DISCARD_ERROR_STACK_LINES = /trackError|record\w*Error|getReducedCallstack|^Error$|promiseReactionJob|native code/;
const STRIP_ERROR_STACK_LINES = /\s*at\s*/;

const EVENT_ACTIONS = {
    PLAY: "play",
    END: "end",
    PAUSE: "pause",
    RESUME: "resume",
    COMPLETION: "completion",
    UI_ACTION: "uiaction",
    LOAD_START: "loadstart",
    LOAD_END: "loadend",
    ERROR: "error",
    CLICK: "click"
};

const ERROR_TYPES = {
    GENERIC: "generic",
    LOAD: "load",
    HLS: "hls",
    AD: "ad"
};

const COMMON_EVENT_DATA = {
    bvpEventCategory: EVENT_CATEGORY,
    event: EVENT_TRACKING_NAME,
    mediaPlayer: `${ PLAYER_NAME }-${ version }`,
    bvpEventValue: 0
};


let dataLayer;
let enabled = false;

/**
 * @class GoogleTagManager
 */
class GoogleTagManager {
    /**
     * @static
     * @param {boolean} isEnabled
     * @param {string} newDataLayerId
     */
    static initGTM(isEnabled, newDataLayerId = null) {
        enabled = Boolean(isEnabled);
        if (!enabled) {
            log.info("GoogleTagManager tracking disabled");
            return;
        }

        const dataLayerId = newDataLayerId || DEFAULT_DATA_LAYER_ID;
        dataLayer = window[dataLayerId];

        if (!dataLayer) {
            log.error(`GTM data layer not found: ${ dataLayerId }`);
            enabled = false;
        }
    }

    /**
     * @static
     * @param {string} label
     * @param {string} details
     * @param {string} [url]
     */
    static trackError(label, details, url = null) {
        this.trackDevEvent({
            bvpEventAction: EVENT_ACTIONS.ERROR,
            bvpEventLabel: label,
            bvpErrorDetails: details,
            bvpCallstack: this._getReducedCallstack(),
            bvpLoaderUrl: url
        });
    }

    /**
     * @static
     * @param {object} eventData
     */
    static trackDevEvent(eventData) {
        const devData = Object.assign({}, {
            bvpEventCategory: EVENT_CATEGORY_DEV
        }, eventData);
        this.trackEvent(devData);
    }

    /**
     * @static
     * @param {object} eventData
     */
    static trackEvent(eventData) {
        if (!enabled) {
            return;
        }

        const gtmData = Object.assign({}, COMMON_EVENT_DATA, this._getExperimentInfo(), eventData);
        const filteredData = Utils.filterEmptyValues(gtmData);
        dataLayer.push(filteredData);
    }

    static _getExperimentInfo() { }

    /**
     * @private
     * @returns {string}
     */
    static _getReducedCallstack() {
        const stack = (new Error()).stack;
        if (!stack) {
            return null;
        }

        const stackLines = stack.split(/\r?\n/);
        const filteredLines = stackLines.reduce((tmp, line) => {
            if (!DISCARD_ERROR_STACK_LINES.test(line)) {
                tmp.push(line.replace(STRIP_ERROR_STACK_LINES, ""));
            }
            return tmp;
        }, []);
        return filteredLines.join("\n");
    }
}


Object.defineProperties(GoogleTagManager, {
    "eventActions": {
        value: EVENT_ACTIONS
    },
    "errorTypes": {
        value: ERROR_TYPES
    }
});

window.BVP_GTM = window.BVP_GTM || GoogleTagManager;
export default GoogleTagManager;
